/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForGcpKubernetesUserManaged extends models.StorageConfigurationForKubernetesUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationForGcpKubernetesUserManaged.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForGcpKubernetesUserManaged>): StorageConfigurationForGcpKubernetesUserManaged {
        let obj = Object.assign(new StorageConfigurationForGcpKubernetesUserManaged(), model);
        StorageConfigurationForGcpKubernetesUserManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForGcpKubernetesUserManaged>): StorageConfigurationForGcpKubernetesUserManaged {
        if (!model) return null;
        return StorageConfigurationForGcpKubernetesUserManaged.newInstance(<StorageConfigurationForGcpKubernetesUserManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForGcpKubernetesUserManaged) {
        if (!obj) return;

        models.StorageConfigurationForGcpKubernetesUserManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForGcpKubernetesUserManaged): boolean {
        if (models.StorageConfigurationForKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForGcpKubernetesUserManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * GCP Bucket Name
     */
    bucket_name: string;

    /**
     * File path prefix in the bucket
     */
    file_path: string;

}
